class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.addEventListener('click', (evt) => {
      const addBtn = evt.target.closest('.cnx__add');
      if (addBtn && addBtn.dataset.vid) this.addComplement(addBtn);
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    this.renderComplement(parsedState.product_id);
  }

  renderComplement(productId) {
    const host = document.getElementById('cart-notif-cross');
    if (!host) return;
    host.innerHTML = '';
    if (!productId) return;
    fetch('/recommendations/products?section_id=cart-crosssell&intent=complementary&limit=6&product_id=' + productId)
      .then((r) => r.text())
      .then((html) => {
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('.cartx');
        if (!el) return;
        const cards = Array.prototype.slice.call(el.querySelectorAll('.cartx__card')).slice(0, 2);
        if (!cards.length) return;
        const esc = (s) => (s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        let rows = '';
        cards.forEach((c) => {
          const img = c.querySelector('.cartx__imgwrap img');
          const nameEl = c.querySelector('.cartx__name');
          const priceEl = c.querySelector('.cartx__price');
          const addBtn = c.querySelector('.cartx__add');
          const vid = addBtn && addBtn.dataset.vid;
          if (!vid) return;
          rows +=
            '<div class="cnx__row">' +
            '<span class="cnx__img">' + (img ? '<img src="' + esc(img.getAttribute('src')) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="cnx__info"><span class="cnx__name">' + esc(nameEl && nameEl.textContent.trim()) + '</span>' +
            '<span class="cnx__price">' + esc(priceEl && priceEl.textContent.trim()) + '</span></span>' +
            '<button type="button" class="cnx__add" data-vid="' + esc(vid) + '">Agregar</button>' +
            '</div>';
        });
        if (rows) host.innerHTML = '<p class="cnx__title">Agrégalo a tu compra</p><div class="cnx__list">' + rows + '</div>';
      })
      .catch(() => {});
  }

  addComplement(btn) {
    btn.disabled = true;
    btn.textContent = 'Añadido';
    const sections = this.getSectionsToRender().map((s) => s.id).join(',');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.vid, quantity: 1, sections: sections, sections_url: window.location.pathname }),
    })
      .then((r) => r.json())
      .then((state) => { if (state && !state.status) this.renderContents(state); })
      .catch(() => { btn.disabled = false; btn.textContent = 'Agregar'; });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
